<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
        let link = document.createElement('link')
        link.setAttribute('rel', 'icon')
        link.setAttribute('type', 'img/x-ico')
        link.setAttribute('href', require('@/assets/image/1.png'))
        document.querySelector('head').appendChild(link)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue